import type { ReactNode, Ref } from "react";

import { EmptyState } from "@similarweb/ui-components";
import { Box } from "@similarweb/ui-components/foundations";

import { translate } from "app/filters/i18nFilter";

import CardLoader from "./CardLoader/CardLoader";
import { StyledCard, StyledCardContentBase } from "./styles";

type CardProps = {
    header?: ReactNode;
    dataAutomation: string;
    className?: string;
    width?: string;
    isLoading?: boolean;
    loader?: ReactNode;
    isEmpty?: boolean;
    emptyState?: ReactNode;
    renderContent: () => ReactNode;
    footer?: ReactNode;
    ref?: Ref<HTMLDivElement>;
};

const Card = (props: CardProps) => {
    const {
        header,
        dataAutomation,
        isLoading = false,
        loader,
        isEmpty = false,
        emptyState,
        className,
        width,
        renderContent,
        footer,
        ref,
    } = props;

    function renderContentOrLoader() {
        if (isLoading) {
            return loader ?? <CardLoader />;
        }

        if (isEmpty) {
            return (
                emptyState ?? (
                    <Box padding="24px">
                        <EmptyState
                            title={translate("si.company-analysis.company-data.card.empty.header")}
                            subtitle={translate("si.company-analysis.company-data.card.empty.text")}
                        />
                    </Box>
                )
            );
        }

        return renderContent();
    }

    return (
        <StyledCard
            ref={ref}
            className={className}
            data-automation={dataAutomation}
            data-automation-loading={isLoading}
            width={width}
        >
            {header}
            <StyledCardContentBase>{renderContentOrLoader()}</StyledCardContentBase>
            {footer}
        </StyledCard>
    );
};

export default Card;
